import { createContext, use } from 'react';
import type { useCopilotSession } from '@customerio/hydra-copilot/react';

type CopilotSession = ReturnType<typeof useCopilotSession>;

// Kept apart from the provider so components the agent renders (which the
// openui library imports) can reach the session without the provider's import
// of that same library closing a cycle.
export const CopilotSessionContext = createContext<CopilotSession | null>(null);

/**
 * The session, or null outside a provider. For components an agent answer can
 * render anywhere a conversation is shown, which should degrade rather than
 * throw where there is no session to talk to.
 */
export function useOptionalCopilotSession() {
  return use(CopilotSessionContext);
}
